/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getRoutes = (currentRouteName, currentRouteComponent) => ({
  browse: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/browse-search/BrowseAndSearchContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')).BrowseAndSearchContainer
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })))
    },
    path: '/:context?/b',
    channel: null
  },

  search: {
    name: 'browse-and-search',
    componentName: 'BrowseAndSearchContainer',
    chunk: () => import(
      /* webpackChunkName: "browse-and-search" */
      './pages/browse-search/BrowseAndSearchContainer.js'
    ),
    get component() {
      return ssr
        // eslint-disable-next-line max-len
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/browse-search/BrowseAndSearchContainer.js')).BrowseAndSearchContainer
        : currentRouteName === 'browse-and-search'
          ? currentRouteComponent
          // eslint-disable-next-line max-len
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.BrowseAndSearchContainer })))
    },
    path: '/:context?/s',
    channel: null
  },

  pep: {
    name: 'pep',
    componentName: 'PepDesktopContainer',
    chunk: () => import(
      /* webpackChunkName: "pep" */
      './pages/pep/PepDesktopContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pep/PepDesktopContainer.js')).PepDesktopContainer
        : currentRouteName === 'pep'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepDesktopContainer })))
    },
    path: '/:context?/pep/:slug?/:itemId',
    channel: 'desktop'
  },

  // @TODO: Named export doesn't match the component file name.
  pepMobile: {
    name: 'pep-mobile',
    componentName: 'PepMobileContainer',
    chunk: () => import(
      /* webpackChunkName: "pep-mobile" */
      './pages/pep/PepMobileContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/pep/PepMobileContainer.js')).PepMobileContainer
        : currentRouteName === 'pep-mobile'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.PepMobileContainer })))
    },
    path: '/:context?/pep/:slug?/:itemId',
    channel: 'mobile'
  },

  product: {
    name: 'product',
    componentName: 'ProductContainer',
    chunk: () => import(
      /* webpackChunkName: "product" */
      './pages/product/ProductContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/product/ProductContainer.js')).ProductContainer
        : currentRouteName === 'product'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.ProductContainer })))
    },
    path: '/:context?/p/:slug?/:itemId',
    channel: null
  },

  compare: {
    name: 'compare',
    componentName: 'CompareContainer',
    chunk: () => import(
      /* webpackChunkName: "compare" */
      './pages/compare/CompareContainer.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/compare/CompareContainer.js')).CompareContainer
        : currentRouteName === 'compare'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.CompareContainer })))
    },
    path: '/:context?/compare',
    channel: null
  },

  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      /* webpackChunkName: "home" */
      './pages/Home.js'
    ),
    get component() {
      return ssr
        ? __webpack_require__(require.resolveWeak('@cwd/src/pages/Home.js')).Home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })))
    },
    path: '/:context?/',
    channel: null
  },
});
